<footer class="app-footer">
  <div class="app-footer-content flex-grow-1">
    Reazly &copy;

    {{ currentYear }}.

    <span class="hidden-mobile"> All rights reserved, </span>

    <span class="fw-bold">{{ appName }}.</span>
  </div>
</footer>
